{
  "familyId": "MET-HOEK-BEREKENEN",
  "questions": [
    {
      "id": "MET-HOEK-BEREKENEN-001",
      "familyId": "MET-HOEK-BEREKENEN",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "hoeken",
      "subSkill": "hoek_berekenen",
      "questionType": "multiple_choice",
      "question": "In een driehoek zijn twee hoeken 65° en 45°. Hoe groot is de derde hoek?",
      "options": ["70°", "80°", "60°", "110°"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Driehoek",
            "content": "Gegeven: hoek A = 65°, hoek B = 45°. Gevraagd: hoek C = ?",
            "icon": "lightbulb"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeken in een driehoek",
            "content": "De drie hoeken van een driehoek zijn samen altijd 180°. Trek de twee bekende hoeken af van 180° om de derde te vinden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_som_driehoek",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De drie hoeken van een driehoek zijn samen altijd 180°. Dit is een basisregel in de meetkunde. Reken: 180° − 65° − 45° = 70°. De derde hoek is 70°. Controleer: 65° + 45° + 70° = 180° ✓.",
        "solutionSteps": [
          "Hoeken in een driehoek zijn samen 180°",
          "180° − 65° = 115°",
          "115° − 45° = 70°",
          "Check: 65° + 45° + 70° = 180° ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 180° − 65° − 45° = 70°.",
          "1": "Je dacht waarschijnlijk dat de hoeken samen 190° zijn. Maar de hoeken in een driehoek zijn altijd samen 180°, niet 190°. Onthoud: driehoek = 180°.",
          "2": "Je dacht waarschijnlijk dat je 65° − 45° = 20° moest uitrekenen en dan 80° − 20° = 60°. Maar je moet allebei de hoeken van 180° aftrekken. Onthoud: 180° − hoek 1 − hoek 2 = hoek 3.",
          "3": "Je dacht waarschijnlijk dat je de twee hoeken moest optellen: 65° + 45° = 110°. Maar dat is het totaal van de twee bekende hoeken, niet de derde hoek. Onthoud: de derde hoek = 180° − de som van de andere twee."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.hoek-som-190", "label": "Denkt dat driehoeksom 190° is", "optionIndex": 1 },
          { "id": "met.hoek-verschil-ipv-aftrekken", "label": "Trekt hoeken van elkaar af i.p.v. van 180°", "optionIndex": 2 },
          { "id": "met.hoek-optellen-ipv-aftrekken", "label": "Telt bekende hoeken op als antwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-HOEK-BEREKENEN-002",
      "familyId": "MET-HOEK-BEREKENEN",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "hoeken",
      "subSkill": "hoek_berekenen",
      "questionType": "multiple_choice",
      "question": "Een gelijkbenige driehoek heeft een tophoek van 40°. Hoe groot zijn de twee basishoeken?",
      "options": ["Allebei 60°", "Allebei 80°", "Allebei 70°", "Allebei 40°"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Gelijkbenige driehoek",
            "content": "Gegeven: tophoek = 40°. De twee basishoeken zijn even groot. Gevraagd: basishoek = ?",
            "icon": "lightbulb"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijkbenige driehoek",
            "content": "Bij een gelijkbenige driehoek zijn de twee basishoeken even groot. Samen met de tophoek is het 180°. Dus: (180° − tophoek) ÷ 2 = basishoek.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_gelijkbenig",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij een gelijkbenige driehoek zijn de twee basishoeken even groot. Samen: 180° − 40° = 140°. Per basishoek: 140° ÷ 2 = 70°. Controleer: 40° + 70° + 70° = 180° ✓.",
        "solutionSteps": [
          "Hoeken samen = 180°",
          "180° − 40° (tophoek) = 140° over voor twee basishoeken",
          "140° ÷ 2 = 70° per basishoek",
          "Check: 40° + 70° + 70° = 180° ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat alle hoeken in een gelijkbenige driehoek 60° zijn. Dat geldt alleen voor een gelijkzijdige driehoek. Onthoud: gelijkbenig = 2 gelijke hoeken, gelijkzijdig = 3 gelijke hoeken van 60°.",
          "1": "Je dacht waarschijnlijk dat je 180° − 40° = 140° niet hoefde te delen. Maar er zijn twee basishoeken, dus je deelt door 2. Onthoud: (180° − tophoek) ÷ 2.",
          "2": "Goed! (180° − 40°) ÷ 2 = 70° per basishoek.",
          "3": "Je dacht waarschijnlijk dat alle hoeken gelijk zijn aan de tophoek. Maar alleen de twee basishoeken zijn gelijk aan elkaar, niet aan de tophoek. Onthoud: basishoek = (180° − tophoek) ÷ 2."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.gelijkbenig-gelijkzijdig-verward", "label": "Verwart gelijkbenig met gelijkzijdig (60°)", "optionIndex": 0 },
          { "id": "met.gelijkbenig-niet-delen", "label": "Vergeet door 2 te delen bij gelijkbenig", "optionIndex": 1 },
          { "id": "met.gelijkbenig-tophoek-gelijk", "label": "Denkt alle hoeken gelijk aan tophoek", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-HOEK-BEREKENEN-003",
      "familyId": "MET-HOEK-BEREKENEN",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "hoeken",
      "subSkill": "hoek_berekenen",
      "questionType": "multiple_choice",
      "question": "Twee hoeken liggen op een rechte lijn. De ene hoek is 125°. Hoe groot is de andere hoek?",
      "options": ["65°", "55°", "35°", "125°"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Rechte lijn",
            "content": "Twee hoeken op een rechte lijn vormen samen een gestrekte hoek (180°). Hoek 1 = 125°. Hoek 2 = ?",
            "icon": "lightbulb"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeken op een rechte lijn",
            "content": "Twee hoeken op een rechte lijn zijn samen altijd 180° (gestrekte hoek). Trek de bekende hoek af van 180°.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_gestrekte_hoek",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Twee hoeken op een rechte lijn vormen samen een gestrekte hoek van 180°. Dit is een basisregel in de meetkunde. Reken: 180° − 125° = 55°. Controleer: 125° + 55° = 180° ✓. Onthoud: een rechte lijn = een gestrekte hoek = altijd 180°.",
        "solutionSteps": [
          "Hoeken op een rechte lijn = 180° (gestrekte hoek)",
          "180° − 125° = 55°",
          "Check: 125° + 55° = 180° ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de hoeken samen 190° zijn. Maar hoeken op een rechte lijn zijn samen 180°. Onthoud: rechte lijn = gestrekte hoek = 180°.",
          "1": "Goed! Hoeken op een rechte lijn zijn samen 180°. Dus 180° − 125° = 55°.",
          "2": "Je dacht waarschijnlijk dat je van 160° moest aftrekken. Maar een rechte lijn is 180°, niet 160°. Onthoud: gestrekte hoek = 180°.",
          "3": "Je dacht waarschijnlijk dat de twee hoeken even groot zijn. Dat is alleen zo als ze allebei 90° zijn. Onthoud: de hoeken zijn samen 180°, maar hoeven niet gelijk te zijn."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.gestrekte-hoek-190", "label": "Denkt gestrekte hoek is 190°", "optionIndex": 0 },
          { "id": "met.gestrekte-hoek-160", "label": "Denkt gestrekte hoek is 160°", "optionIndex": 2 },
          { "id": "met.gestrekte-hoek-gelijk", "label": "Denkt hoeken op lijn altijd gelijk", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-HOEK-BEREKENEN-004",
      "familyId": "MET-HOEK-BEREKENEN",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "hoeken",
      "subSkill": "hoek_berekenen",
      "questionType": "multiple_choice",
      "question": "Een vierhoek heeft hoeken van 90°, 80° en 110°. Hoe groot is de vierde hoek?",
      "options": ["100°", "90°", "70°", "80°"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Vierhoek",
            "content": "Gegeven: hoek A = 90°, hoek B = 80°, hoek C = 110°. Gevraagd: hoek D = ?",
            "icon": "lightbulb"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeken in een vierhoek",
            "content": "De vier hoeken van een vierhoek zijn samen altijd 360°. Trek de drie bekende hoeken af van 360°.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_som_vierhoek",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De vier hoeken van een vierhoek zijn samen altijd 360°. Stap 1: tel de bekende hoeken op: 90° + 80° + 110° = 280°. Stap 2: trek af van 360°: 360° − 280° = 80°. Controleer: 90° + 80° + 110° + 80° = 360° ✓. Waarom 360°? Omdat je een vierhoek kunt verdelen in twee driehoeken: 2 × 180° = 360°.",
        "solutionSteps": [
          "Hoeken in een vierhoek = 360°",
          "Tel de bekende hoeken op: 90° + 80° + 110° = 280°",
          "Trek af: 360° − 280° = 80°",
          "Check: 90° + 80° + 110° + 80° = 360° ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de vierde hoek 100° is. Maar 90° + 80° + 110° + 100° = 380°, en dat is meer dan 360°. Onthoud: controleer altijd of het totaal 360° is.",
          "1": "Je dacht waarschijnlijk dat de vierde hoek ook 90° is. Maar dat klopt alleen als de andere drie hoeken samen 270° zijn. Hier: 90° + 80° + 110° = 280°, dus de vierde is 80°.",
          "2": "Je dacht waarschijnlijk dat je van 180° moest aftrekken. Maar dat geldt voor een driehoek. Bij een vierhoek zijn de hoeken samen 360°. Onthoud: driehoek = 180°, vierhoek = 360°.",
          "3": "Goed! De hoeken in een vierhoek zijn samen 360°. De drie bekende hoeken: 90° + 80° + 110° = 280°. Dus 360° − 280° = 80°."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.vierhoek-som-fout", "label": "Rekenfout bij optellen drie hoeken", "optionIndex": 0 },
          { "id": "met.vierhoek-aanname-90", "label": "Neemt aan dat vierde hoek 90° is", "optionIndex": 1 },
          { "id": "met.vierhoek-driehoek-verward", "label": "Gebruikt 180° i.p.v. 360° voor vierhoek", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-HOEK-BEREKENEN-005",
      "familyId": "MET-HOEK-BEREKENEN",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "hoeken",
      "subSkill": "hoek_berekenen",
      "questionType": "fill_in",
      "question": "In een driehoek zijn twee hoeken 50° en 90°. Hoe groot is de derde hoek? Typ je antwoord in graden (bijv. 40).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["40", "40°"],
        "caseSensitive": false,
        "placeholder": "?°"
      },
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Rechthoekige driehoek",
            "content": "Gegeven: hoek A = 50°, hoek B = 90° (rechte hoek). Gevraagd: hoek C = ?",
            "icon": "lightbulb"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeken in een driehoek",
            "content": "De drie hoeken van een driehoek zijn samen altijd 180°. Trek de twee bekende hoeken af: 180° − 50° − 90° = 40°.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_som_driehoek_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De drie hoeken van een driehoek zijn samen altijd 180°. Hier heb je een rechthoekige driehoek (één hoek is 90°). Reken: 180° − 50° − 90° = 40°. Controleer: 50° + 90° + 40° = 180° ✓. Tip: bij een rechthoekige driehoek zijn de twee scherpe hoeken samen altijd 90° (want 180° − 90° = 90°).",
        "solutionSteps": [
          "Hoeken in een driehoek = 180°",
          "180° − 50° − 90° = 40°",
          "Check: 50° + 90° + 40° = 180° ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.hoek-som-190", "label": "Rekent met 190° i.p.v. 180° als driehoeksom" },
          { "id": "met.hoek-verschil-ipv-aftrekken", "label": "Trekt hoeken van elkaar af i.p.v. van 180°" }
        ]
      }
    },
    {
      "id": "MET-HOEK-BEREKENEN-006",
      "familyId": "MET-HOEK-BEREKENEN",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "hoeken",
      "subSkill": "hoek_berekenen",
      "questionType": "multiple_choice",
      "question": "Een timmerman maakt een dakconstructie. De twee dakhellingen vormen een driehoek met een tophoek van 120°. De twee basishoeken zijn even groot. Hoe groot is elke basishoek?",
      "options": ["60°", "30°", "40°", "20°"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Dakconstructie",
            "content": "De twee dakhellingen vormen een gelijkbenige driehoek. Tophoek = 120°. De twee basishoeken zijn even groot.",
            "icon": "lightbulb"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijkbenige driehoek",
            "content": "Bij een gelijkbenige driehoek zijn de twee basishoeken even groot. Samen met de tophoek is het 180°. Dus: (180° − tophoek) ÷ 2 = basishoek.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_context_dak",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De dakconstructie vormt een gelijkbenige driehoek met een tophoek van 120°. De twee basishoeken zijn even groot. Reken: 180° − 120° = 60° over voor twee basishoeken. Per basishoek: 60° ÷ 2 = 30°. Controleer: 120° + 30° + 30° = 180° ✓. In de bouw is de tophoek belangrijk: een platter dak (grotere tophoek) geeft kleinere basishoeken.",
        "solutionSteps": [
          "Hoeken in een driehoek = 180°",
          "180° − 120° (tophoek) = 60° over voor twee basishoeken",
          "60° ÷ 2 = 30° per basishoek",
          "Check: 120° + 30° + 30° = 180° ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 180° − 120° = 60° niet hoefde te delen. Maar er zijn twee basishoeken, dus je deelt door 2: 60° ÷ 2 = 30°. Onthoud: (180° − tophoek) ÷ 2 = basishoek.",
          "1": "Goed! (180° − 120°) ÷ 2 = 30° per basishoek. De timmerman weet nu de hoek van elke dakhelling.",
          "2": "Je dacht waarschijnlijk dat je 120° ÷ 3 = 40° moest rekenen. Maar de drie hoeken zijn niet gelijk — alleen de twee basishoeken zijn gelijk. Onthoud: trek eerst de tophoek af, deel dan door 2.",
          "3": "Je dacht waarschijnlijk dat je 120° ÷ 6 = 20° moest rekenen. Maar de berekening is: (180° − 120°) ÷ 2 = 30°. Onthoud: begin altijd bij het totaal van 180°."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.gelijkbenig-niet-delen-context", "label": "Vergeet door 2 te delen bij context", "optionIndex": 0 },
          { "id": "met.gelijkbenig-delen-door-3", "label": "Deelt tophoek door 3 i.p.v. rest door 2", "optionIndex": 2 },
          { "id": "met.gelijkbenig-delen-door-6", "label": "Deelt tophoek door 6", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-HOEK-BEREKENEN-007",
      "familyId": "MET-HOEK-BEREKENEN",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "hoeken",
      "subSkill": "hoek_berekenen",
      "questionType": "step_solver",
      "question": "Een driehoek heeft hoeken van 55° en 80°. Bereken de derde hoek stap voor stap.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          {
            "prompt": "Hoeveel graden zijn de hoeken van een driehoek samen?",
            "correctAnswer": "180",
            "acceptedAnswers": ["180", "180°"],
            "hint": "De hoeken van een driehoek zijn samen altijd ... graden."
          },
          {
            "prompt": "Tel de twee bekende hoeken op: 55° + 80° = ?",
            "correctAnswer": "135",
            "acceptedAnswers": ["135", "135°"],
            "hint": "55 + 80 = ?"
          },
          {
            "prompt": "Trek het totaal af van 180°: 180° − 135° = ?",
            "correctAnswer": "45",
            "acceptedAnswers": ["45", "45°"],
            "hint": "180 − 135 = ?"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Driehoek",
            "content": "Gegeven: hoek A = 55°, hoek B = 80°. Gevraagd: hoek C = ?",
            "icon": "lightbulb"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeken in een driehoek",
            "content": "De drie hoeken van een driehoek zijn samen altijd 180°. Trek de twee bekende hoeken af van 180°.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_som_driehoek_step",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De drie hoeken van een driehoek zijn samen 180°. Stap 1: tel de bekende hoeken op: 55° + 80° = 135°. Stap 2: trek af van 180°: 180° − 135° = 45°. De derde hoek is 45°.",
        "solutionSteps": [
          "Hoeken in een driehoek = 180°",
          "55° + 80° = 135°",
          "180° − 135° = 45°",
          "Check: 55° + 80° + 45° = 180° ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.hoek-som-190", "label": "Vergeet bij stap-aftrekken dat driehoeksom 180° is" },
          { "id": "met.hoek-optellen-ipv-aftrekken", "label": "Vergeet bij stap-aftrekken om van 180° af te trekken" }
        ]
      }
    }
  ]
}